import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseGroupPolicy extends BasePolicy {
    create(user, groupIds) {
        if (!groupIds) {
            return user.hasPermissionTo('create a course group');
        }

        return user.hasGroupPermissionTo('create a course group');
    }
}
